export default __webpack_public_path__ + "static/media/31.51d4892c.jpg";